import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SignUpGreatWorkStep.module.scss';
import StepTitle from '../../../../Features/StepTitle/StepTitle';
import GoToQuestionnaireButton from './Fetaures/GoToQuestionnaireButton';

function SignUpGreatWorkStepDesktop() {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <StepTitle>{t('signup.greatwork.title')}</StepTitle>
      <GoToQuestionnaireButton buttonLabel={t('signup.greatwork.button.desktop')} />
    </div>
  );
}

export default SignUpGreatWorkStepDesktop;
